// import { useUserTransactionsStore } from "store/userTransaction/useUserTransactionsStore";
// import { useWalletStore } from "store/wallet/useWalletStore";
import { AuthStorage } from "services/auth/AuthStorage";
import { SessionManager } from "../../auth/sessionManager";
import userHttp from "../../axios.services/instances/userHttp";
import {
  normalizeApiResponse,
  ServiceCallResult,
} from "../cashQuinHttpResponse/cashQuinHttpResponse";
import {
  LoginRequestDto,
  LoginSuccessDto,
  RegisterRequestDto,
  RegisterSuccessDto,
} from "./userServiceType";

const userService = {
  login: async (
    payload: LoginRequestDto,
  ): Promise<ServiceCallResult<LoginSuccessDto>> => {
    const loginRes = await userHttp.post("/api/login", {
      email: payload.email,
      passwordHash: payload.password,
    });

    const normalizeLoginRes = normalizeApiResponse<LoginSuccessDto>(
      loginRes,
      loginRes.status,
    );

    if (!normalizeLoginRes.status || !normalizeLoginRes.data?.token) {
      return {
        ok: false,
        statusCode: normalizeLoginRes.statusCode,
        message: normalizeLoginRes.message || "Login failed",
        errors: normalizeLoginRes.errors,
        raw: normalizeLoginRes,
      };
    }

    const { token, expiresAtUtc } = normalizeLoginRes.data;
    SessionManager.setAccessToken(token, expiresAtUtc);

    // STORE USER INFO in localStorage (single object)
    AuthStorage.setUser({
      userId: normalizeLoginRes.data.userId || null,
      userName: String(
        normalizeLoginRes.data.userName || normalizeLoginRes.data.name,
      ),
      userEmail: String(
        normalizeLoginRes.data.userEmail || normalizeLoginRes.data.email,
      ),
      userMobile: String(
        normalizeLoginRes.data.userMobile || normalizeLoginRes.data.mobile,
      ),
    });
    return { ok: true, value: normalizeLoginRes.data, raw: normalizeLoginRes };
  },

  register: async (
    payload: RegisterRequestDto,
  ): Promise<ServiceCallResult<RegisterSuccessDto>> => {
    const req: RegisterRequestDto = {
      ...payload,
    };

    const httpRes = await userHttp.post("/api/register", req);

    const api = normalizeApiResponse<RegisterSuccessDto>(
      httpRes,
      httpRes.status,
    );

    if (!httpRes.status) {
      return {
        ok: false,
        statusCode: api.statusCode,
        message: api.message || "Registration failed",
        errors: api.errors,
        raw: api,
      };
    }
    return { ok: true, value: api.data ?? {}, raw: api };
  },

  fetchSession: async () => {
    const httpRes = await userHttp.get("/session");
    return normalizeApiResponse<unknown>(httpRes.data, httpRes.status);
  },

  logout: async () => {
    SessionManager.clear();
    AuthStorage.clear();
    // useWalletStore.getState().clear();
    // useUserTransactionsStore.getState().clear();

    const httpRes = await userHttp.post("/api/v1/auth/logout");

    return normalizeApiResponse<unknown>(httpRes.data, httpRes.status);
  },
};

export default userService;

// import { SessionManager } from "../../auth/sessionManager";
// import userHttp from "../../axios.services/instances/userHttp";

// export interface RegisterPayload  {
//   email: string;
//   mobile: string;
//   password: string;
//   fullName: string;
//   aadharNumber: string;
//   panNumber: string;
//   address: string;
//   profileImage: string | null;    // base64 string (without data: prefix)
//   imgExtenstion: string;   // e.g. "jpg", "png"

// }

// const userService = {
//   login: async (payload: { email: string; password: string }) => {
//     const response = await userHttp.post("/api/login", {
//       email: payload.email,
//       passwordHash: payload.password,
//     });

//     console.log({ response });

//     const wrapper = response?.data;
//     const inner = wrapper?.Data ?? wrapper;

//     const { token, sessionId, expiresAtUtc, userId, role } = inner;
//     SessionManager.setAuth({ token, sessionId, expiresAtUtc });

//     return { userId, role, token, sessionId, expiresAtUtc };
//   },
//   register: async (payload: RegisterPayload) => {

//     // console.log({payload});

//     const response = await userHttp.post("/api/register", {
//       email: payload.email,
//       mobile: payload.mobile,
//       password: payload.password,
//       fullName: payload.fullName,
//       aadharNumber: payload.aadharNumber,
//       panNumber: payload.panNumber,
//       address: payload.address,
//       profileImage: payload.profileImage,
//       imgExtenstion: payload.imgExtenstion
//     });

//     // console.log({response});

//     const wrapper = response?.data;
//     const inner = wrapper?.Data ?? wrapper;
// // console.log({inner});
//     // assume: { message, userId, ... } aata hai
//     return inner;
//   },

//   fetchSession: async () => {
//     const response = await userHttp.get(`/session`);
//     return response?.data ?? response;
//   },

//   logout: async () => {
//     SessionManager.clear();
//     const response = await userHttp.post(`/logout`);

//     return response?.data ?? response;
//   },
// };

// export default userService;
